import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from 'src/app/actions';
import { AppConfig } from 'src/config/AppConfig';
import {
  getClientConfig,
  getClientSecurity,
  getClientTypes,
  getNmsDashAlerts,
  getServicerAppSecurity,
  updateAlertStatus
} from 'src/config/firebaseConfig';
import {
  BrandConfigData,
  BrandSecurityData,
  ClientTypeBrand,
} from 'src/types/brand';
import {
  NmsAlertData,
  Alert,
  //BrandSecurityData,
  //ClientTypeBrand,
} from 'src/types/nms';
import {
  ClientTypeLocation,
  LocationConfigData,
  LocationSecurityData,
} from 'src/types/location';
import { updateClientConfig, updateSelectedFilter } from './filterSlice';
import { UserProfile } from 'src/interfaces/user';
import { transformBrandsCollection, transformAlertIdCollection } from 'src/utils/Utils';
import {updateAlertStatusChange, fetchDataWithoutParams} from 'src/api/filterApi';

export interface AppDataState {
  brands: Record<string, ClientTypeBrand> | null;
  brandsAsList: ClientTypeBrand[] | [];
  brandsConfig: Record<string, BrandConfigData> | null;
  nmsdashConfig: Record<string, BrandConfigData> | null;
  nmsdashAlert: Record<string, NmsAlertData> | null;
  nmsAlertAsList: Alert[] | [];
  brandsSecurity: Record<string, BrandSecurityData> | null;
  locationConfig: Record<string, LocationConfigData> | null;
  locations: Record<string, ClientTypeLocation> | null;
  locationsAsList: ClientTypeLocation[] | [];
  locationSecurity: Record<string, LocationSecurityData> | null;
  servicerAppSecurity: Record<string, BrandSecurityData> | null;
  loading: boolean;
  error: string | null; // Changed to string for error messages
  selectedMenu: string;
  selectedReportTile: string;
  sideMenuWidth: number;
  isinit: boolean;
}

const initialState: AppDataState = {
  brands: null,
  brandsAsList: [],
  locations: null,
  locationsAsList: [],
  loading: false,
  error: null,
  brandsConfig: null,
  nmsdashConfig: null,
  nmsdashAlert: null,
  nmsAlertAsList: [],
  brandsSecurity: null,
  locationConfig: null,
  locationSecurity: null,
  servicerAppSecurity: null,
  selectedMenu: localStorage.getItem('selectedMenu') || 'transactions',
  selectedReportTile:
    localStorage.getItem('selectedReportTile') || 'transactions',
  sideMenuWidth: 240,
  isinit: false,
};

export const getInitData = createAsyncThunk<any, { userProfile: UserProfile }>(
  'appData/getInitData',
  async (
    { userProfile }: { userProfile: UserProfile },
    { dispatch, rejectWithValue, getState },
  ) => {  
    let brands = {};
    //let locations = {};
    console.log('getInitData');
    for (const clientTypeObj of AppConfig.clientTypeList) {
      const clientType = clientTypeObj.id;
      const snapshot = await getClientTypes(clientType);
      const configSnapshot = await getClientConfig(clientType);
      const clientSecuritySnapshot = await getClientSecurity(clientType);
      const nmsAlertSnapshot = await getNmsDashAlerts();

      if (snapshot.exists()) {
        const data: Record<string, ClientTypeBrand | ClientTypeLocation> =
          snapshot.val();

        if (clientType == 'Brand') {
          brands = data;
          dispatch(setClientBrands(data as Record<string, ClientTypeBrand>));

          if (configSnapshot.exists())
            dispatch(setBrandsConfig(configSnapshot.val()));
          if (clientSecuritySnapshot.exists())
            dispatch(setBrandsSecurity(clientSecuritySnapshot.val()));
        } else if (clientType == 'NMS'){
          brands = data;
          dispatch(setClientBrands(data as Record<string, ClientTypeBrand>));

          if (configSnapshot.exists()){
            dispatch(setNmsdashConfig(configSnapshot.val()))
          }
          if (nmsAlertSnapshot.exists()){
            dispatch(setNmsdashAlert(nmsAlertSnapshot.val()))
          }
        } else {

        if (configSnapshot.exists())
          dispatch(setLocationConfig(configSnapshot.val()));
        if (clientSecuritySnapshot.exists())
          dispatch(setLocationSecurity(clientSecuritySnapshot.val()));

        if (!configSnapshot.exists()) {
            console.error('no Config loaded');
            return rejectWithValue('Config not loaded');
        }
        const config = configSnapshot.val();
        console.log ("CONFIG LOCATIONS LOADED", config);

       if (!config) {
         console.error('no Config loaded--LOCATIONS');
         return rejectWithValue('Config not loaded-LOCATIONS');
       }

       const headers = {
         Authorization: config['HEADER']['Authorization'],
       };
      await dispatch(
         getLocationData({
          url: config.API_URL.location_data,
          headers,
        }));

        const locations = getState().appData.locations;

          dispatch(
            updateSelectedFilter({
              key: 'account',
              value: '' + userProfile?.dash.activeLocationPartner,
            }),
          );
          dispatch(
            setClientLocations(locations as Record<string, ClientTypeLocation>),
          );
        }
      }
      if (userProfile?.dash.activeType === 'Brand' || userProfile?.dash.activeType === 'NMS') {
      //if (userProfile?.dash.activeType === 'Brand') {
        const option = userProfile?.dash.activeBrand;
        dispatch(
          updateSelectedFilter({
            key: 'account',
            value: '' + '' + brands[option].bq_concept_name,
          }),
        );
        dispatch(
          updateClientConfig({
            ...brands[option],
            brandKey: option,
          }),
        );
      } else {

        const locations = getState().appData.locations;

        if (!locations || !locations[option]) {
           console.error('Invalid location for option:', option);
           return rejectWithValue('Invalid location');
        }

        const option = userProfile?.dash.activeLocationPartner;
        dispatch(
          updateSelectedFilter({
            key: 'account',
            value: '' + option,
          }),
        );
        dispatch(
          updateClientConfig({
            ...locations[option],
            brandKey: option,
          }),
        );
      }
    }
    const serviceSnapShot = await getServicerAppSecurity();
    if (serviceSnapShot.exists())
      dispatch(setServicerAppSecurity(serviceSnapShot.val()));

    return true;
  },
);

export const getLocationData = createAsyncThunk(
  'auth/getLocationData',
  async (
    {
      url,
      headers,
    }: {
      url: string;
      headers: Record<string, string>; 
    },
    { getState, rejectWithValue },
  ) => {
     
    try {
      const response = await fetchDataWithoutParams(url, headers);
      console.log('LocationsData logs resposne--', response);
      return response;
    } catch (error) {
      console.error(error);
      return rejectWithValue('No data Found');
    }
  },
);

export const updateAlertStatusToFirebase = createAsyncThunk(
  'auth/updateAlertStatus',
  async (
    { id, data }: { id: string; data: number; },
    { getState, rejectWithValue },
  ) => {
    //const { selectedFilter, interactions } = getState().filters;
    try {
      let response = null;
      response = await updateAlertStatus(id, data)
      console.log('Alert Status response--', response);
      return response;
    } catch (error) {
      console.error(error);
      return rejectWithValue('Error updating Alert Status');
    }
  },
);

export const alertStatusChangeLogs = createAsyncThunk(
  'filters/alertStatusChangeLogs',
  async (
    {
      url,
      headers,
      alertId,
      alertType,
      alertStatus,
      userName,
      userEmail,
      timeStamp,
    }: {
      url: string;
      headers: Record<string, string>;
      alertId: string;
      alertType: string;
      alertStatus: string;
      userName: string;
      userEmail: string;
      timeStamp: string;
    },
    { getState, rejectWithValue },
  ) => {
    const params = {
      alertId,
      alertType,
      alertStatus,
      userName,
      userEmail,
      timeStamp,
    };

    try {
      const response = await updateAlertStatusChange(url, headers, params);
      console.log('Alert Status log update response--', response);
      return response;
    } catch (error) {
      console.error(error);
      return rejectWithValue('Alert Status log unable to update');
    }
  },
);

const appDataSlice = createSlice({
  name: 'appData',
  initialState,
  reducers: {
    setClientBrands: (
      state,
      action: PayloadAction<Record<string, ClientTypeBrand>>,
    ) => {
      state.brands = action.payload;
      state.brandsAsList = transformBrandsCollection(
        action.payload,
      ) as ClientTypeBrand[];
    },
    setClientLocations: (
      state,
      action: PayloadAction<Record<string, ClientTypeLocation>>,
    ) => {
      state.locations = action.payload;
      state.locationsAsList = transformBrandsCollection(
        action.payload,
      ) as ClientTypeLocation[];
    },
    setBrandsConfig: (
      state,
      action: PayloadAction<Record<string, BrandConfigData>>,
    ) => {
      state.brandsConfig = action.payload;
    },
    setBrandsSecurity: (
      state,
      action: PayloadAction<Record<string, BrandSecurityData>>,
    ) => {
      state.brandsSecurity = action.payload;
    },
    setNmsdashConfig:(
      state,
      action: PayloadAction<Record<string, BrandConfigData>>,
    ) => {
      state.nmsdashConfig = action.payload;
    },
    setNmsdashAlert:(
      state,
      action: PayloadAction<Record<string, NmsAlertData>>,
    ) => {
      state.nmsdashAlert = action.payload;
      state.nmsAlertAsList = transformAlertIdCollection(
        action.payload.alerts,
      ) as Alert[];
      console.log("NMS ALERTLIST", state.nmsAlertAsList);
    },
    setServicerAppSecurity: (
      state,
      action: PayloadAction<Record<string, BrandSecurityData>>,
    ) => {
      state.servicerAppSecurity = action.payload;
    },
    setLocationConfig: (
      state,
      action: PayloadAction<Record<string, LocationConfigData>>,
    ) => {
      state.locationConfig = action.payload;
    },
    setLocationSecurity: (
      state,
      action: PayloadAction<Record<string, LocationSecurityData>>,
    ) => {
      state.locationSecurity = action.payload;
    },
    setSelectedMenu: (state, action: PayloadAction<string>) => {
      state.selectedMenu = action.payload;
    },
    setSelectedReportTile: (state, action: PayloadAction<string>) => {
      state.selectedReportTile = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSideMenuWidth: (state, action: PayloadAction<number>) => {
      state.sideMenuWidth = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // You can add async actions with builder.addCase() here later.
    builder
      .addCase(logout, () => initialState)
      .addCase(getInitData.pending, (state) => {
        state.isinit = false;
        state.error = null;
      })
      .addCase(getInitData.fulfilled, (state, action) => {
        state.isinit = true;
      })
      .addCase(getInitData.rejected, (state, action) => {
        state.isinit = false;
        state.error = 'init failed';
      })
      .addCase(getLocationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocationData.fulfilled, (state, action) => {

        const Locationdata  = action.payload.locations;
        console.log("Locations Details:", Locationdata);


        state.locations = Locationdata; 
        console.log("Locations Details in State:", state.locations);

        state.loading = false;
      })
      .addCase(getLocationData.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          'Failed to fetch Locationdata ' + action.meta.arg.url;
      })
      .addCase(updateAlertStatusToFirebase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAlertStatusToFirebase.fulfilled, (state, action) => {
        const alertId = action.meta.arg.id;
        if (state.nmsdashAlert?.alerts?.[alertId]) {
          state.nmsdashAlert.alerts[alertId].enabled = action.meta.arg.data;
        }
        state.loading = false;
      })
      .addCase(updateAlertStatusToFirebase.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          'Failed to update alert status on firebase ';
      })
      .addCase(alertStatusChangeLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(alertStatusChangeLogs.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(alertStatusChangeLogs.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          'Failed to update alert status logs on bigquery ';
      });
  },
});

export const {
  setClientBrands,
  setClientLocations,
  setBrandsConfig,
  setNmsdashConfig,
  setNmsdashAlert,
  setBrandsSecurity,
  setLocationConfig,
  setLocationSecurity,
  setServicerAppSecurity,
  setSelectedMenu,
  setLoading,
  setSelectedReportTile,
  setError,
  setSideMenuWidth,
} = appDataSlice.actions;

export default appDataSlice.reducer;
